import {applyMultipleFilter, applySingleFilter, filterOffers, offerPriceFilter} from '@/utils/filter-helpers'
import {distanceAdapter, ratingByClientsFeedbackAdapter, supplierRatingAdapter} from '@/utils/hotels/hotel-transformers'

export const distanceFromLatLng = (lat1, lng1, lat2, lng2) => {
    const deg2rad = deg => deg * (Math.PI / 180),
        square = x => Math.pow(x, 2),
        r = 6371 //radius of the earth in km
    lat1 = deg2rad(lat1)
    lat2 = deg2rad(lat2)
    const lat_dif = lat2 - lat1,
        lng_dif = deg2rad(lng2 - lng1),
        a = square(Math.sin(lat_dif / 2)) + Math.cos(lat1) * Math.cos(lat2) * square(Math.sin(lng_dif / 2))
    return 2 * r * Math.asin(Math.sqrt(a))
}

// DEFINE FILTER FUNCTIONS
const fn = {}
fn.price = function (offer, values) {
    offer.rooms = offer.rooms.filter(room => offerPriceFilter(room, values))
    return offer.rooms.length > 0
}

fn.category = function (offer, values, filter) {
    return applySingleFilter(offer, filter, values)
}

fn.tripadvisorRating = function (offer, values, filter) {
    return offer[filter] && values.indexOf(String(offer[filter].rating)) !== -1
}

fn.location = function (offer, values, filter) {
    return applySingleFilter(offer, filter, values)
}

fn.district = function (offer, values, filter) {
    return applySingleFilter(offer, filter, values)
}

fn.specialOffer = function (offer, values) {
    if (values.length === 1) {
        offer.rooms = offer.rooms.filter(room => {
            const isSpecialOffer = room.specialOffer || room.price.discountDetails

            return values[0] === 'special_offer' ? isSpecialOffer : !isSpecialOffer
        })

        return offer.rooms.length > 0
    }

    return true
}

fn.wishlist = function (offer) {
    return offer.wishlist
}

fn.type = function (offer, values, filter) {
    return applySingleFilter(offer, filter, values)
}

fn.distance = function (offer, values) {
    if (values.some(v => v === 'e_more_than_5')) return true
    const distanceArr = distanceAdapter(offer.distance)

    return values.some(value => distanceArr.some(d => d === value))
}

fn.chain = function (offer, values, filter) {
    return applySingleFilter(offer, filter, values)
}

fn.services = function (offer, values, filter) {
    return applyMultipleFilter(offer, filter, values)
}

fn.classifications = function (offer, values, filter) {
    return applyMultipleFilter(offer, filter, values)
}

fn.supplierCode = function (offer, values, filter) {
    return values.every(
        val => (val === 'own' && offer[filter].indexOf('company.') === 0) || offer[filter].indexOf(val) !== -1
    )
}

fn.supplierName = function (offer, values) {
    offer.rooms = offer.rooms.filter(({hotelSupplierName}) => {
        return values.includes(hotelSupplierName)
    })
    return offer.rooms.length > 0
}

fn.availability = function (offer, values) {
    offer.rooms = offer.rooms.filter(room => {
        if (room.soldOut) return false

        const key = room.available ? 'available' : 'on_request'
        const index = values.indexOf(key)
        return index >= 0
    })
    return offer.rooms.length > 0
}

fn.shared = function (offer, values) {
    offer.rooms = offer.rooms.filter(room => {
        const index = values.indexOf(room.shared)
        return index >= 0
    })
    return offer.rooms.length > 0
}

fn.cancellationPolicy = function (offer, values) {
    offer.rooms = offer.rooms.filter(room => {
        const index = values.indexOf(room.cancellationLabel)
        return index >= 0
    })
    return offer.rooms.length > 0
}

fn.roomTypes = function (offer, values) {
    offer.rooms = offer.rooms.filter(room => {
        const index = values.indexOf(room.name)
        return index >= 0
    })
    return offer.rooms.length > 0
}

fn.mealTypes = function (offer, values) {
    offer.rooms = offer.rooms.filter(({mealTypeStandardCode}) => {
        return values.includes(mealTypeStandardCode)
    })
    return offer.rooms.length > 0
}

fn.bedTypes = function (offer, values) {
    offer.rooms = offer.rooms.filter(({bedTypes}) => {
        return bedTypes.some(bed => values.includes(bed.nameToken))
    })
    return offer.rooms.length > 0
}

fn.name = function (offer, values) {
    return offer.name.toLowerCase().includes(values.toLowerCase())
}

fn.map = function (offer, values) {
    if (values.center && offer.coordinates) {
        const {lat: lat1, lng: lng1} = values.center,
            [lat2, lng2] = offer.coordinates
        return values.radius >= distanceFromLatLng(lat1, lng1, lat2, lng2) * 1000
    }
    return true
}

fn.popularServices = function (offer, values, filter) {
    return applyMultipleFilter(offer, filter, values)
}

fn.roomServices = function (offer, values, filter) {
    return applyMultipleFilter(offer, filter, values)
}

fn.supplierRating = function (offer, values, filter) {
    return values.includes(supplierRatingAdapter(offer[filter]?.rating || 0))
}

fn.ratingByClientsFeedback = function (offer, values, filter) {
    return values.includes(ratingByClientsFeedbackAdapter(offer[filter]?.rating))
}

//END DEFINE FILTER FUNCTIONS

export {fn}

export default function (offers, filters) {
    return filterOffers(offers, filters, fn)
}
